import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilsCopyButtonDirective } from './utils-copy-button.directive';

@NgModule({
  declarations: [UtilsCopyButtonDirective],
  imports: [CommonModule],
  exports: [UtilsCopyButtonDirective]
})
export class UtilsCopyButtonModule {}
